module.exports = __webpack_public_path__ + "img/market-store.a5e92fd6.png";